module.exports = __webpack_public_path__ + "static/media/ar.11f0ffbe.png";